import React from 'react';
import Manage from './Manage';
import { VendorsProvider } from '../../../contexts/VendorContext';


const VendorsPage = () => {
    return (
        <VendorsProvider>
            <Manage />
        </VendorsProvider>
    );
};

export default VendorsPage;
